import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { StockOperation } from '../../models/stock-operation.model';
import { MOVEMENT_ADJUSTMENT } from '../../models/product-stock-movement.model';
import { StockService } from '../../services/stock.service';
import { StockOperationValidatorService } from '../../validators/stock-operation-validator.service';

@Component({
    selector: 'app-stock-adjustment',
    templateUrl: './stock-adjustment.component.html',
    styleUrls: ['./stock-adjustment.component.scss'],
    standalone: false
})
export class StockAdjustmentComponent {

  operation: StockOperation = new StockOperation();

  operationType: string = MOVEMENT_ADJUSTMENT;

  isError: boolean = false;
  isServerError: boolean = false;
  serverErrorMessage: string = '';

  constructor(private stockOperationValidator: StockOperationValidatorService,
    private stockService: StockService,
    private router: Router) { }

  /**
   * The whole batch goes up in one request because the backend runs it in a single
   * transaction. An adjustment carries a signed qty, so the validator allows a negative one.
   */
  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.serverErrorMessage = '';

    if (this.stockOperationValidator.isValid(this.operation, false, true)) {
      this.stockService.adjustment(this.operation)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        this.serverErrorMessage = e.error && e.error.message ? e.error.message : '';
        return e;
      }))
      .subscribe((levels) => {
        this.router.navigate(['/warehousing/stock-movement-labels'], { state: { levels } });
      })
    } else {
      this.isError = true;
    }
  }
}
